import React from "react";
import { Link } from "react-router-dom";
import Helmet from "react-helmet";
import { Icon, Card, Row, Col, Pagination } from "antd";
import { connect } from "react-redux";
import { API } from "aws-amplify";
import Loading from "components/loading";

import * as Styled from "./styled";

const API_URL = process.env.REACT_APP_API_URL;

class Listings extends React.Component {
  state = {
    data: {
      results: []
    },
    page: 1,
    loading: true
  };

  componentWillMount() {
    this.fetch(1);
  }

  filterNonMapable = results => {};

  fetch = page => {
    this.setState({ loading: true });
    API.get(
      "api",
      `etsy/stores/${this.props.currentStoreId}/listings?page=${page}`
    ).then(
      data => {
        this.setState({
          data,
          loading: false
        });
      },
      err => {
        console.log(err);
        this.setState({
          loading: false
        });
      }
    );
  };

  onPageChange = page => {
    this.setState({
      page
    });
    this.fetch(page);
  };

  renderCard = item => {
    const { is_digital } = item;
    const imgUrl = `${API_URL}api/etsy/stores/${this.props.currentStoreId}/${item.listing_id}`;

    const coverWithLink = (
      <Link to={`/listings/${item.listing_id}`}>
        <img src={imgUrl} />
      </Link>
    );
    const titleWithLink = (
      <Link to={`/listings/${item.listing_id}`}>{item.title}</Link>
    );

    return (
      <Col key={item.listing_id} xs={24} sm={12} md={8} lg={6} xl={6} xxl={4}>
        <Card
          cover={
            is_digital ? <img src={imgUrl} /> : coverWithLink
          }
          style={{ marginTop: 16 }}
        >
          <Card.Meta
            title={
              is_digital ? (
                <span title="Digital product cannot be mapped">
                  <Icon type="cloud-download" />&nbsp;{item.title}
                </span>
              ) : (
                titleWithLink
              )
            }
          />
        </Card>
      </Col>
    );
  };

  render() {
    const { data, page, loading } = this.state;

    return (
      <Styled.Container>
        <Helmet title="Store Listings"/>
        <h1>Store Listings</h1>
        <p>Here are the listings from your Etsy store. Click on a listing to view/edit/add a Mapping. Digital Download products are not mappable so they are not editable.</p>
        {loading ? (
          <Loading />
        ) : (
          <Row gutter={24} type="flex">
            {data.results.map(this.renderCard)}
          </Row>
        )}
        <br />
        <Pagination
          className="text-center"
          defaultPageSize={24}
          current={page}
          total={data.count}
          onChange={this.onPageChange}
        />
      </Styled.Container>
    );
  }
}

export default connect(state => state.session)(Listings);
